import { getUser } from '@frontend/auth-helpers';
import { usePrefBootstrap } from './bootstrap';
import { usePreferencesInitializer } from './usePreferencesInitializer';

/**
 * Custom hook to initialize preference-related state.
 * Internally calls usePreferencesInitializer and usePrefBootstrap.
 */
export const useInitializePreferences = () => {
  const user = getUser();

  // Initialize user preferences when userID is available
  usePreferencesInitializer(user?.userID);

  // Bootstrap preferences
  usePrefBootstrap();
};
